/* ==========================================================================
   Mundo Dos Filtros — predictive-search.js
   Busca instantânea: sugere produtos enquanto o cliente digita, usando a
   Predictive Search API + Section Rendering API da Shopify.
   ========================================================================== */

(function () {
  'use strict';

  var rotas = (window.tema && window.tema.rotas) || {};
  var ESPERA = 250;   // ms sem digitar antes de consultar
  var MINIMO = 2;     // letras mínimas para valer a consulta

  function $(seletor, escopo) {
    return (escopo || document).querySelector(seletor);
  }

  function $$(seletor, escopo) {
    return Array.prototype.slice.call((escopo || document).querySelectorAll(seletor));
  }

  function iniciar() {
    $$('[data-busca]').forEach(function (caixa) {
      if (caixa.dataset.buscaIniciada === 'sim') return;
      caixa.dataset.buscaIniciada = 'sim';

      var campo = $('input[name="q"]', caixa);
      var painel = $('[data-busca-painel]', caixa);
      var status = $('[data-busca-status]', caixa);
      if (!campo || !painel) return;

      var espera = null;
      var requisicao = null;   // controla a chamada em voo
      var ultimoTermo = '';

      function abrir() {
        painel.hidden = false;
        campo.setAttribute('aria-expanded', 'true');
      }

      function fechar() {
        painel.hidden = true;
        campo.setAttribute('aria-expanded', 'false');
        marcarAtivo(-1);
      }

      function avisar(texto) {
        if (status) status.textContent = texto;
      }

      function buscar(termo) {
        /* Cancela a consulta anterior. Sem isso, uma resposta lenta de um termo
           antigo pode chegar depois e sobrescrever o resultado do termo novo. */
        if (requisicao) requisicao.abort();
        requisicao = new AbortController();

        /* O "fields" faz a sugestão instantânea procurar no SKU também. Sem
           ele a lista sai vazia para quem digita o código da peça e só enche
           depois de enviar o formulário, onde a busca completa acha. */
        var url = rotas.previsao + '?q=' + encodeURIComponent(termo) +
                  '&resources[type]=product,collection,page' +
                  '&resources[limit]=6' +
                  '&resources[options][fields]=title,product_type,variants.title,variants.sku,vendor' +
                  '&section_id=predictive-search';

        caixa.classList.add('esta-carregando');

        fetch(url, { signal: requisicao.signal })
          .then(function (resposta) {
            if (!resposta.ok) throw new Error('busca indisponível');
            return resposta.text();
          })
          .then(function (html) {
            var novo = new DOMParser()
              .parseFromString(html, 'text/html')
              .querySelector('[data-busca-resultados]');

            painel.innerHTML = novo ? novo.innerHTML : '';
            caixa.classList.remove('esta-carregando');
            abrir();

            var achados = $$('[data-busca-item]', painel).length;
            avisar(achados > 0 ? achados + ' sugestões' : 'Nenhum resultado');
          })
          .catch(function (erro) {
            if (erro.name === 'AbortError') return;
            /* Falhou a sugestão? O formulário continua funcionando no Enter. */
            caixa.classList.remove('esta-carregando');
            fechar();
          });
      }

      campo.addEventListener('input', function () {
        var termo = campo.value.trim();
        window.clearTimeout(espera);

        if (termo.length < MINIMO) {
          if (requisicao) requisicao.abort();
          fechar();
          return;
        }

        if (termo === ultimoTermo && !painel.hidden) return;
        ultimoTermo = termo;

        espera = window.setTimeout(function () { buscar(termo); }, ESPERA);
      });

      campo.addEventListener('focus', function () {
        if (campo.value.trim().length >= MINIMO && painel.innerHTML.trim()) abrir();
      });

      /* ------------------------------------------------------- Teclado -- */

      var ativo = -1;

      function itens() {
        return $$('[data-busca-item]', painel);
      }

      function marcarAtivo(indice) {
        var lista = itens();
        ativo = indice;
        lista.forEach(function (item, i) {
          item.classList.toggle('esta-ativo', i === indice);
          if (i === indice) item.setAttribute('aria-selected', 'true');
          else item.removeAttribute('aria-selected');
        });
        if (indice >= 0 && lista[indice]) {
          lista[indice].scrollIntoView({ block: 'nearest' });
        }
      }

      campo.addEventListener('keydown', function (evento) {
        var lista = itens();

        if (evento.key === 'Escape') {
          fechar();
          return;
        }

        if (painel.hidden || !lista.length) return;

        if (evento.key === 'ArrowDown') {
          evento.preventDefault();
          marcarAtivo((ativo + 1) % lista.length);
        } else if (evento.key === 'ArrowUp') {
          evento.preventDefault();
          marcarAtivo(ativo <= 0 ? lista.length - 1 : ativo - 1);
        } else if (evento.key === 'Enter' && ativo >= 0) {
          /* Só sequestra o Enter quando há um item destacado pelas setas.
             Sem destaque, o formulário envia normalmente para a busca. */
          evento.preventDefault();
          window.location.href = lista[ativo].href;
        }
      });

      /* Clique fora fecha */
      document.addEventListener('click', function (evento) {
        if (!caixa.contains(evento.target)) fechar();
      });

      /* Foco saindo da caixa fecha (navegação por Tab) */
      caixa.addEventListener('focusout', function () {
        window.setTimeout(function () {
          if (!caixa.contains(document.activeElement)) fechar();
        }, 0);
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }

  document.addEventListener('shopify:section:load', iniciar);
})();
